"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = exports.AnalyticsProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var AnalyticsContext = (0, react_1.createContext)(null);
var AnalyticsProvider = function (_a) {
    var analytics = _a.client, children = _a.children;
    return ((0, jsx_runtime_1.jsx)(AnalyticsContext.Provider, __assign({ value: {
            analytics: analytics,
        } }, { children: children })));
};
exports.AnalyticsProvider = AnalyticsProvider;
// Create an analytics hook that we can use with other components.
var useAnalytics = function () {
    var result = (0, react_1.useContext)(AnalyticsContext);
    if (!result) {
        throw new Error('Missing AnalyticsState.');
    }
    return result;
};
exports.useAnalytics = useAnalytics;
//# sourceMappingURL=analytics.context.js.map